import { Menu, Tooltip } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { noop } from 'lodash';
import useApproveAction from 'components/tables/data/revision/actions/hooks/use-approve-action';
import { useConfirm } from 'components/modals/message/MessageProvider';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the user who has the permission to approve the revision.
 */
export default function ApproveAction({ revision, onStatusChange = noop, kind }: RevisionSingleActionProps) {
  const { approveRevision } = useApproveAction();
  const { confirm } = useConfirm();

  /**
   * Confirms the approval of the revision.
   */
  const confirmApproveRevision = () =>
    confirm({
      title: revision.kind === 'revision' ? 'Schválenie revíznej správy' : 'Schválenie formulára',
      content:
        revision.kind === 'revision'
          ? 'Naozaj si prajete schváliť túto revíznu správu?'
          : 'Naozaj si prajete schváliť tento formulár?',
      onConfirm: () => approveRevision({ revision, onStatusChange }),
    });

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Schváliť" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="primary" size="md" onClick={confirmApproveRevision}>
          <IconCheck stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button
        size="md"
        onClick={confirmApproveRevision}
        leftIcon={<IconCheck stroke={1.5} size={24} />}
        variant="primary"
        w={188}
      >
        Schváliť
      </Button>
    );
  }

  return (
    <Menu.Item color="gray.8" onClick={confirmApproveRevision} icon={<IconCheck stroke={1.5} size={24} />}>
      Schváliť
    </Menu.Item>
  );
}
